import { trackEvent } from '@raisin/events-tracking';
import { CUSTOMER_PORTAL_COMMON_EVENT_PROPERTIES, CustomerPortalEvent } from 'eventsTracking';

export type OnBankListSortedParams = {
  sortingCriteria: string;
  distributorId: string;
  eventName: string;
};

const createBankListSortedEvent = ({
  sortingCriteria,
  distributorId,
  eventName,
}: OnBankListSortedParams) =>
  ({
    ...CUSTOMER_PORTAL_COMMON_EVENT_PROPERTIES,
    context: 'category-management-banks',
    eventName,
    object: 'list_of_banks',
    action: 'sorted',
    product_id: '',
    customerGroup: distributorId,
    customAttribute1: 'Bank list page',
    customAttribute2: sortingCriteria,
  } as CustomerPortalEvent);

export const handleBankListSort = (params: OnBankListSortedParams) => {
  trackEvent(createBankListSortedEvent(params), true);
};
